import { IConfig } from '@cian/config/shared';
import {
  MAX_POSITIONS_TOP_10_ALL,
  MAX_POSITIONS_TOP_10_COM,
  MAX_POSITIONS_TOP_20_ALL,
  MAX_POSITIONS_TOP_5_ALL,
  MAX_POSITIONS_TOP_5_COM,
} from '../../constants/maxPositionsInRating';

import { TRatingType } from '../../types/filters';

const hasElemInPos = (array: string[], slug: string) => array.find(elem => elem === slug);

const getPosForAll = (config: IConfig, slug: string) => {
  const allPos10 = config.get<string[]>('info-agency-rating-frontend.maxRegionPosAll10') || MAX_POSITIONS_TOP_10_ALL;

  const allPos20 = config.get<string[]>('info-agency-rating-frontend.maxRegionPosAll20') || MAX_POSITIONS_TOP_20_ALL;

  const allPos5 = config.get<string[]>('info-agency-rating-frontend.maxRegionPosAll5') || MAX_POSITIONS_TOP_5_ALL;

  switch (slug) {
    case hasElemInPos(allPos10, slug):
      return 10;
    case hasElemInPos(allPos20, slug):
      return 20;
    case hasElemInPos(allPos5, slug):
      return 5;
    default:
      return 30;
  }
};

const getPosForCom = (config: IConfig, slug: string) => {
  const comPos5 = config.get<string[]>('info-agency-rating-frontend.maxRegionPosCom5') || MAX_POSITIONS_TOP_5_COM;

  const comPos10 = config.get<string[]>('info-agency-rating-frontend.maxRegionPosCom10') || MAX_POSITIONS_TOP_10_COM;

  switch (slug) {
    case hasElemInPos(comPos5, slug):
      return 5;
    case hasElemInPos(comPos10, slug):
      return 10;
    default:
      return 30;
  }
};

export const getRatingPosCount = (config: IConfig, slug: string, type: TRatingType): number => {
  return type === 'all' ? getPosForAll(config, slug) : getPosForCom(config, slug);
};
